module.exports = __webpack_public_path__ + "img/order_pending.92a92f9c.png";